import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core'

import { TranslatePipe } from '@ngx-translate/core'
import { Button } from 'primeng/button'
import { takeUntil } from 'rxjs'

import { Action, Resource, Role } from '@ti/contracts'
import { AppCommonModule } from '@ti/core/common/common.module'
import { injectDestroy$ } from '@ti/core/common/utils'
import { PlusIconComponent } from '@ti/core/icons/plus'
import { FleetHeaderComponent } from '@ti/core/ui-kit/layout/components/fleet-header/fleet-header.component'

import { BaseRoleEditModel, BaseRolesListModel } from '../../models'
import { RolesManager } from '../../services'
import { EditRoleDialogComponent } from '../edit/edit-role-dialog.component'
import { RoleManagementGridComponent } from '../grid/role-management-grid.component'

@Component({
  selector: 'app-role-management-page',
  templateUrl: 'role-management-page.component.html',
  styleUrls: ['role-management-page.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    AppCommonModule,
    Button,
    EditRoleDialogComponent,
    FleetHeaderComponent,
    PlusIconComponent,
    RoleManagementGridComponent,
    TranslatePipe,
  ],
})
export class RoleManagementPageComponent implements OnInit {
  protected readonly editModel = inject(BaseRoleEditModel)
  protected readonly listModel = inject(BaseRolesListModel)
  protected readonly rolesManager = inject(RolesManager)
  protected readonly destroy$ = injectDestroy$()

  public ngOnInit() {
    this.initListAndEditModelsSync()
  }

  protected async duplicateAndOpen(role: Role) {
    // Close the form
    this.editModel.resetForm()

    const duplicated = await this.rolesManager.duplicate(role)
    if (duplicated) {
      await this.editModel.edit(duplicated)
    }
  }

  protected initListAndEditModelsSync() {
    this.listModel.state.selectedItem$.pipe(takeUntil(this.destroy$)).subscribe((selectedRole) => {
      const editedRoleData = this.editModel.state.editedRoleData()
      if (selectedRole && selectedRole.id !== editedRoleData?.id) {
        this.editModel.edit(selectedRole)
      } else if (!selectedRole && editedRoleData) {
        this.editModel.resetForm()
      }
    })
    this.editModel.state$.editedRoleData.pipe(takeUntil(this.destroy$)).subscribe((editedRole) => {
      if (editedRole && editedRole.id !== this.listModel.selectedItem?.id) {
        this.listModel.select({ ...editedRole, usersCount: 0 })
      } else if (!editedRole && this.listModel.selectedItem) {
        this.listModel.unselect()
      }
    })
  }

  protected readonly TYPES = { Action, Resource }
}
